'use client';

import { createContext, useContext, useState } from 'react';
const ResourceContext = createContext<any>(undefined);
export function ResourceWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  const [resource, setResource] = useState<any>();
  const [setPath] = useState('');
  const [docUrl, setDocUrl] = useState('');
  const [relatedAssets, setRelatedAssets] = useState('');
  const [cdnEnv, setCdnEnv] = useState<any>('');
  return <ResourceContext.Provider value={{
    relatedAssets,
    setRelatedAssets,
    resource,
    setResource,
    setPath,
    setDocUrl,
    docUrl,
    cdnEnv,
    setCdnEnv
  }} data-sentry-element="unknown" data-sentry-component="ResourceWrapper" data-sentry-source-file="resourceContext.tsx">
   {children}
  </ResourceContext.Provider>;
}
export function useResourceContext() {
  return useContext(ResourceContext);
}